var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "app" } }, [
    _c(
      "div",
      { staticClass: "app-contain" },
      [
        _c(
          "keep-alive",
          [
            _vm.isRouterAlive && _vm.$route.meta.keepAlive
              ? _c("router-view")
              : _vm._e(),
          ],
          1
        ),
        _vm.isRouterAlive && !_vm.$route.meta.keepAlive
          ? _c("router-view")
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }